<template>
    <div id="data-not-found" class="w-full flex justify-center items-center min-h-not-found-body">
        <div class="h-full w-fit flex flex-col items-center justify-center">
            <div id="img-data-not-found" class="h-80 w-80 max-md:h-60 max-md:w-60">
                <img :src="dataNFImage" alt="Data no encontrada" class="h-full w-full">
            </div>
            <span class="font-bloggerB text-big-text-news-desktop text-gray-text mt-special dark:text-primary-dark-text">{{ message }}</span>
        </div>
    </div>
</template>

<script setup>
import { generalStore } from '@/stores';
const store = generalStore();

const props = defineProps([
    'message'
])

let dataNFImage = store.STORAGE_URL + 'Utils/noData.svg';
</script>